
import { Component } from '@angular/core';
import { Container, Main } from 'tsparticles';
import { ChatService } from './providers/chat.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  constructor(public _cs:ChatService) {

  }

  id = "tsparticles";

    /* Starting from 1.19.0 you can use a remote url (AJAX request) to a JSON with the configuration */
    particlesUrl = "http://foo.bar/particles.json";

    /* or the classic JavaScript object */
    particlesOptions = {

        background: {
          color: {
            value: "#000000"
          },
          position: "50% 50%",
          repeat: "no-repeat",
          size: "cover"
        },
        "fullScreen": {
          "enable": true
        },
        "interactivity": {
          "events": {
            "onClick": {
              "enable": true,
              "mode": "push"
            },
            "onHover": {
              "mode": "repulse"
            }
          },
          "modes": {
            "bubble": {
              "distance": 400,
              "duration": 2,
              "opacity": 0.8,
              "size": 40
            },
            "grab": {
              "distance": 400
            },
            "push": {
              "groups": [
                "z5000",
                "z7500",
                "z2500",
                "z1000"
              ]
            }
          }
        },
        "particles": {
          "color": {
            "animation": {
              "h": {
                "speed": 20
              }
            }
          },
          "groups": {
            "z5000": {
              "number": {
                "value": 70
              },
              "zIndex": {
                "value": 5000
              }
            },
            "z7500": {
              "number": {
                "value": 30
              },
              "zIndex": {
                "value": 7500
              }
            },
            "z2500": {
              "number": {
                "value": 50
              },
              "zIndex": {
                "value": 2500
              }
            },
            "z1000": {
              "number": {
                "value": 40
              },
              "zIndex": {
                "value": 1000
              }
            }
          },
          "links": {
            "color": {
              "value": "#ffffff"
            },
            "opacity": 0.4
          },
          "move": {
            "angle": {
              "value": 10
            },
            "attract": {
              "rotate": {
                "x": 600,
                "y": 1200
              }
            },
            "direction": "right",
            "enable": true,
            "outModes": {
              "bottom": "out",
              "left": "out",
              "right": "out",
              "top": "out"
            },
            "speed": 5
          },
          "number": {
            "value": 200
          },
          "opacity": {
            "animation": {
              "speed": 3,
              "minimumValue": 0.1
            }
          },
          "zIndex": {
            "value": 500,
            "opacityRate": 0.5
          }
        },
        "emitters": {
          "autoPlay": true,
          "life": {},
          "rate": {
            "quantity": 1,
            "delay": 7
          },
          "size": {
            "mode": "percent",
            "height": 0,
            "width": 0
          },
          "particles": {
            "shape": {
              "type": "images",
              "options": {
                "images": {
                  "src": "https://particles.js.org/images/cyan_amongus.png",
                  "width": 500,
                  "height": 634
                }
              }
            },
            "size": {
              "value": 40
            },
            "move": {
              "speed": 10,
              "outModes": {
                "default": "destroy",
                "left": "none"
              },
              "straight": true
            },
            "zIndex": {
              "value": 0
            },
            "rotate": {
              "value": {
                "min": 0,
                "max": 360
              },
              "animation": {
                "enable": true,
                "speed": 10,
                "sync": true
              }
            }
          },
          "position": {
            "x": 0,
            "y": 55
          }
        }

    };

    particlesLoaded(container: Container): void {
        console.log(container);
    }
    particlesInit(main: Main): void {
         console.log(main);
    // Starting from 1.19.0 you can add custom presets or shape here, using the current tsParticles instance (main)
     }
}
